/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'home',
    title: 'Home',
    type: 'basic',
    icon: 'mat_outline:home',
    link: '/home',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'day-record',
    title: 'Registro de Jornada',
    type: 'basic',
    icon: 'mat_outline:timer',
    link: '/registro-jornada',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'clients',
    title: 'Clientes',
    type: 'basic',
    icon: 'mat_outline:groups',
    link: '/clientes',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'schedule',
    title: 'Agenda',
    type: 'basic',
    icon: 'mat_outline:calendar_today',
    link: '/agenda',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'schedule2',
    title: 'Agenda2',
    type: 'basic',
    icon: 'mat_outline:calendar_today',
    link: '/agenda2',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: true }
  },
  {
    id: 'first_interview',
    title: '1ªs Entrevistas',
    type: 'basic',
    icon: 'mat_outline:calendar_today',
    link: '/primeras-entrevistas',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'tasks',
    title: 'Tareas',
    type: 'basic',
    icon: 'heroicons_outline:view-boards',
    link: '/tareas',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'administration',
    title: 'Administracion',
    type: 'group',
    icon: 'mat_outline:admin_panel_settings',
    classes: {
      title: 'text-white',
      subtitle: 'text-white',
      wrapper: 'text-white'
    },
    meta: { isAdmin: true },
    link: '/administracion',
    children: [
      {
        id: 'professionals',
        title: 'Profesionales',
        type: 'basic',
        icon: 'iconsmind:professor',
        link: '/administracion/profesionales',
        classes: { wrapper: 'text-white' },
        meta: { isAdmin: true }
      },
      {
        id: 'treatments',
        title: 'Tratamientos',
        type: 'basic',
        icon: 'iconsmind:brain',
        link: '/administracion/tratamientos',
        classes: { wrapper: 'text-white' },
        meta: { isAdmin: true }
      },
      {
        id: 'finances',
        title: 'Contabilidad',
        type: 'basic',
        icon: 'mat_outline:euro',
        link: '/administracion/contabilidad',
        classes: { wrapper: 'text-white' },
        meta: { isAdmin: true }
      },
      {
        id: 'history-working-day',
        title: 'Historial Registro de Jornada',
        type: 'basic',
        icon: 'mat_outline:table_chart',
        link: '/administracion/historial-registro-diario',
        classes: { wrapper: 'text-white' },
        meta: { isAdmin: true }
      }
    ]
  }
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'home',
    title: 'Home',
    type: 'basic',
    icon: 'mat_outline:home',
    link: '/home',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false },
    children: []
  },
  {
    id: 'day-record',
    title: 'Registro de Jornada',
    type: 'basic',
    icon: 'mat_outline:timer',
    link: '/registro-jornada',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false },
    children: []
  },
  {
    id: 'clients',
    title: 'Clientes',
    type: 'basic',
    icon: 'mat_outline:groups',
    link: '/clientes',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false },
    children: []
  },
  {
    id: 'schedule',
    title: 'Agenda',
    type: 'basic',
    icon: 'mat_outline:calendar_today',
    link: '/agenda',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'schedule2',
    title: 'Agenda2',
    type: 'basic',
    icon: 'mat_outline:calendar_today',
    link: '/agenda2',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'first_interview',
    title: '1E',
    type: 'basic',
    icon: 'mat_outline:contact_phone',
    link: '/primeras-entrevistas',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false }
  },
  {
    id: 'tasks',
    title: 'Tareas',
    type: 'basic',
    icon: 'heroicons_outline:view-boards',
    link: '/tareas',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false },
    children: []
  },
  {
    id: 'blog',
    title: 'Blog',
    type: 'basic',
    icon: 'mat_outline:menu_book',
    link: '/blog',
    classes: { wrapper: 'text-white' },
    meta: { isAdmin: false },
    children: []
  },
  {
    id: 'administration',
    title: 'Administracion',
    type: 'aside',
    icon: 'mat_outline:admin_panel_settings',
    classes: {
      subtitle: 'text-white',
      wrapper: 'text-white'
    },
    meta: { isAdmin: true },
    link: '/administracion',
    children: []
  }
];
